import toDate from '../to-date';

export const isAfter = (firstDate: Date | number, secondDate: Date | number): boolean => {
  return toDate(firstDate).getTime() > toDate(secondDate).getTime();
};

export default isAfter;
